import React, { useEffect, useState } from "react";
import { apiFetchCohortWorkbook, apiFetchTableauTicket } from "../../actions/storyboardApi";
import Tableau from "../../components/Tableau/Tableau";
import { getViz } from "../../components/Tableau/TableauViz";
import { Workbook } from "../../types/Storyboard";
import {CohortDataset} from "../HealthcareUsageReport/types/CohortQuery";

interface Props {
    cohortId: string
    dataset: CohortDataset
}

const VIZ_ELEMENT_ID = "tableauViz"
export const FILTER_COHORT_ID = "Cohort Id"

const ReportTableau = ({ cohortId, dataset }: Props) => {

    const [ticket, setTicket] = useState<string | null>(null)
    const [tableauView, setTableauView] = useState<Workbook | null>(null)
    useEffect(() => {
        apiFetchTableauTicket().then((ticket) => setTicket(ticket))
        apiFetchCohortWorkbook(dataset).then((view) => {
            if (view) {
                setTableauView(view)
            } else {
                console.log('Cohort workbook view was undefined.')
            }
        })
    }, [dataset]);

    const [ready, setReady] = useState<boolean>(false)
    useEffect(() => {
        if (ticket && tableauView) {
            setReady(true)
        }
    }, [ticket, tableauView])

    useEffect(() => {
        const viz = getViz()
        if (viz && viz.current) {
            // @ts-ignore
            viz.current.getWorkbook().getActiveSheet().applyFilterAsync(FILTER_COHORT_ID, cohortId, tableau.FilterUpdateType.REPLACE)
        }
    }, [cohortId])

    return (
        <div id={VIZ_ELEMENT_ID}>
            {ready ?
                // If ready, load the viz
                <Tableau
                    parentElement={document.getElementById(VIZ_ELEMENT_ID)!}
                    dashboardURL={tableauView!.viewURL}
                    ticket={ticket!}
                    vizOptions={{
                        hideTabs: true,
                        hideToolbar: false,
                        width: '100%',
                        height: '900px',
                        // https://kb.tableau.com/articles/howto/how-to-disable-caching-for-embedded-workbooks-using-embed-code
                        // https://kb.tableau.com/articles/Issue/set-different-caching-settings-for-different-workbooks
                        ':refresh': 'y',
                        [FILTER_COHORT_ID]: cohortId
                    }}
                /> :
                // Otherwise, return nothing
                null
            }
        </div>
    )

}

export default ReportTableau